/* eslint-env node */

"use strict";

module.exports = require("./lib/DayPicker");
module.exports.DateUtils = require("./lib/DateUtils");
module.exports.LocaleUtils  = require("./lib/LocaleUtils");



//////////////////
// WEBPACK FOOTER
// ./~/react-day-picker/DayPicker.js
// module id = 1224
// module chunks = 0